


export const HomePageExplore = [
    {
        tag: 'Free',
        courses: [
            {
                heading: "Learn HTML",
                description: "Master the fundamentals of HTML to create and structure web pages. Learn to add text, links, images, and other elements to build a strong foundation in web development.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Learn CSS",
                description: "Dive into CSS basics to style and layout your web pages effectively. Explore topics like colors, fonts, box model, and selectors to create visually appealing designs.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Responsive Web Design",
                description: "Learn how to create responsive web designs that adapt seamlessly to different devices and screen sizes, enhancing user experience across platforms.",
                level: 'Beginner',
                lessionNumber: 6
            },
        ]
    },
    {
        tag: 'New to coding',
        courses: [
            {
                heading: "HTML",
                description: "Start your coding journey by learning HTML to structure web content. Understand the basics of tags, elements, and creating simple web pages.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "CSS",
                description: "Discover how to style web pages using CSS. Learn the essentials of designing layouts, customizing appearances, and adding interactivity.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Responsive",
                description: "Understand the principles of responsive design to build web pages that look great on any device, from desktops to smartphones.",
                level: 'Beginner',
                lessionNumber: 6
            },
        ]
    },
    {
        tag: 'Most popular',
        courses: [
            {
                heading: "Java",
                description: "Learn Java programming from scratch, focusing on core concepts like variables, loops, classes, and building small applications.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Python",
                description: "Explore Python programming, known for its simplicity and versatility. Learn to write scripts, automate tasks, and solve real-world problems.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "SCSS",
                description: "Get hands-on with SCSS to create maintainable and modular stylesheets for scalable web applications.",
                level: 'Beginner',
                lessionNumber: 6
            },
        ]
    },
    {
        tag: 'Skills paths',
        courses: [
            {
                heading: "Flask",
                description: "Learn Flask, a Python web framework, to create robust and dynamic web applications with ease.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Django",
                description: "Master Django, a high-level Python framework, to build secure, scalable, and database-driven websites.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Fast API",
                description: "Understand FastAPI, a modern web framework for building APIs quickly with Python, focusing on speed and ease of use.",
                level: 'Beginner',
                lessionNumber: 6
            },
        ]
    },
    {
        tag: 'Career paths',
        courses: [
            {
                heading: "Next.js",
                description: "Learn Next.js, a React-based framework, to build fast and SEO-friendly web applications with server-side rendering.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Nuxt.js",
                description: "Master Nuxt.js to develop versatile and high-performance web applications using the power of Vue.js.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Sanity",
                description: "Explore Sanity, a modern content management system, to create dynamic and headless content-driven websites.",
                level: 'Beginner',
                lessionNumber: 6
            },
        ]
    },
];
